module.exports = __webpack_public_path__ + "img/trainningAppointmentListNull.512a40ff.png";